import { z } from 'zod';
import { stringArraySchema, timestampSchema } from './shared';

export const projectRowSchema = z.object({
  slug: z.string().min(1),
  title: z.string().min(1),
  tag: z.string(),
  tags: stringArraySchema,
  outcome: z.string(),
  associatedWith: z.string().nullable(),
  description: z.string(),
  image: z.string().nullable(),
  link: z.string().nullable(),
  sortOrder: z.number().int(),
  visible: z.boolean(),
  updatedAt: timestampSchema,
});

export const projectInsertSchema = z.object({
  slug: z.string().min(1),
  title: z.string().min(1),
  tag: z.string(),
  tags: stringArraySchema.optional(),
  outcome: z.string(),
  associatedWith: z.string().nullable().optional(),
  description: z.string(),
  image: z.string().nullable().optional(),
  link: z.string().nullable().optional(),
  sortOrder: z.number().int().optional(),
  visible: z.boolean().optional(),
});

export const projectUpdateSchema = projectInsertSchema.partial();

export type ProjectRow = z.infer<typeof projectRowSchema>;
export type ProjectInsert = z.input<typeof projectInsertSchema>;
export type ProjectUpdate = z.input<typeof projectUpdateSchema>;
